import { DateTime } from 'luxon';
import React from 'react';
import { match } from 'ts-pattern';
import { IAvailabilityInfo } from './components/types';
import { useIsSoldOut } from './sold-out-notifications/useIsSoldOut';
import { TrialShefModals } from './trial-modal/TrialShefModals';

interface IConsumerOrderModalsProps {
  availabilityInfo: IAvailabilityInfo[];
  deliveryDate?: DateTime;
  shefId: string;
  shefName: string;
  shefImageUrl?: string | null;
  isTrialShef: boolean;
  isEditingOrder: boolean;
}

export const ConsumerOrderModals: React.FC<IConsumerOrderModalsProps> = ({
  availabilityInfo,
  deliveryDate,
  shefName,
  shefId,
  shefImageUrl,
  isTrialShef,
  isEditingOrder,
}) => {
  const { modalVisible: isSoldOut, isOrderingAllRemainingItems } = useIsSoldOut({
    availabilityInfo,
    deliveryDate,
    shefId,
    isEditingOrder,
  });

  if (isSoldOut && isEditingOrder) return null;

  return match({ isSoldOut, isEditingOrder, isOrderingAllRemainingItems, isTrialShef })
    .with({ isSoldOut: true, isEditingOrder: true }, () => null)
    .with({ isSoldOut: true }, { isOrderingAllRemainingItems: true, isEditingOrder: false }, () => null)
    .with({ isTrialShef: false }, { isEditingOrder: true }, () => null)
    .otherwise(() => (
      <TrialShefModals
        isTrialShef={isTrialShef}
        shefId={shefId}
        shefName={shefName}
        shefImageUrl={shefImageUrl}
        isEditingOrder={isEditingOrder}
      />
    ));
};
